module.exports = __webpack_public_path__ + "static/media/watermark_logo.ce8e8787.svg";